import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/p4h5h94e_Capture%20d%E2%80%99%C3%A9cran%202026-01-21%20171314.jpg" 
              alt="Riviera Rope Access" 
              className="h-16 w-auto"
            />
            <div className="ml-3">
              <h1 className="text-xl font-bold text-blue-900">Riviera Rope Access</h1>
              <p className="text-xs text-slate-600">Travaux d'accès difficile</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-blue-700 font-medium transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('certifications')} className="text-slate-700 hover:text-blue-700 font-medium transition-colors">
              Certifications
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-blue-700 text-white px-6 py-2 rounded-lg hover:bg-blue-800 transition-colors font-medium">
              Demander un devis
            </button>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-slate-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-100 rounded">
              Services
            </button>
            <button onClick={() => scrollToSection('certifications')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-100 rounded">
              Certifications
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 bg-blue-700 text-white hover:bg-blue-800 rounded">
              Demander un devis
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;